import Vue from "vue";
import Router from "vue-router";
import BimProgressAdmin from "../components/BimProgressAdmin";
import BimProgressDashBoard from "../components/BimProgressDashBoard";
import RtkAnalysis from "../components/RtkAnalysis";
import OilSupplyAnalysis from "../components/OilSupplyAnalysis";
import Login from "../components/Login";
import SSO from "../components/SSO";
import A from "../components/place/A";
import B from "../components/place/B";
import C from "../components/place/C";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Main",
      alias: "/main",
      component: BimProgressAdmin,
    },
    {
      path: "/login",
      name: "Login",
      alias: "/login",
      component: Login,
    },
    {
      path: "/bim/:id",
      name: "BimProgressAdmin",
      component: BimProgressAdmin,
    },
    {
      path: "/sso/:token",
      name: "SSO",
      component: SSO,
    },
    {
      path: "/dashboard/:id",
      name: "BimProgressDashBoard",
      component: BimProgressDashBoard,
      meta: { viewMode: "bim" },
      alias: "/dashboard/:id/bim",
    },
    {
      path: "/dashboard/:id/map",
      name: "BimProgressDashBoardMap",
      component: BimProgressDashBoard,
      meta: { viewMode: "map" },
    },
    {
      path: "/dashboard/:id/analysis",
      name: "RtkAnalysis",
      component: RtkAnalysis,
      meta: { viewMode: "analysis" },
    },
    {
      path: "/dashboard/:id/oil-supply",
      name: "OilSupplyAnalysis",
      component: OilSupplyAnalysis,
      meta: { viewMode: "oil-supply" },
    },
    {
      path: "/a",
      name: "A",
      component: A,
    },
    {
      path: "/b",
      name: "B",
      component: B,
    },
    {
      path: "/c",
      name: "C",
      component: C,
    },
  ],
});

export default router;
